module.exports = __webpack_public_path__ + "static/img/report-side-img.45ab462.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/report-side-img.png
// module id = ZZvy
// module chunks = 1